<template>
  <div class="page_">
    <pdf
      :src="pdfUrl"
      :page="pageNum"
      ref="pdf"
      @num-pages="pageTotalNum = $event"
    ></pdf>
    <div class="btn_a">
      <button class="btn-def btn-pre" @click.stop="prePage">上一页</button>
      <button class="btn-def btn-next" @click.stop="nextPage">下一页</button>
      <button
        class="btn-def"
        :class="{ select: idx == 0 }"
        @touchstart="idx = 0"
        @touchend="idx = -1"
        @click="scaleD"
      >
        放大
      </button>
      <button
        class="btn-def"
        :class="{ select: idx == 1 }"
        @touchstart="idx = 1"
        @touchend="idx = -1"
        @click="scaleX"
      >
        缩小
      </button>
      <div>{{ pageNum }}/{{ pageTotalNum }}</div>
    </div>
  </div>
</template>
<script>
import pdf from 'vue-pdf'
export default {
  props: ['pdfUrl'],
  data() {
    return {
      policyNo: '',
      src: '',
      progress: null,
      pageNum: 1,
      pageTotalNum: 1,
      curPageNum: 0,
      loadedRatio: 0,
      scale: 100, //放大系数
      idx: -1
    }
  },
  components: {
    pdf
  },
  created() {
    const { pNo, type } = this.$route.query
    this.policyNo = pNo ? pNo : ''
    if (this.policyNo && !type) {
      //
    }
  },
  methods: {
    prePage() {
      let p = this.pageNum
      p = p > 1 ? p - 1 : this.pageTotalNum
      this.pageNum = p
    },
    nextPage() {
      let p = this.pageNum
      p = p < this.pageTotalNum ? p + 1 : 1
      this.pageNum = p
    },
    //放大
    scaleD() {
      this.scale += 5
      this.$refs.pdf.$el.style.width = parseInt(this.scale) + '%'
    },

    //缩小
    scaleX() {
      if (this.scale == 100) {
        return
      }
      this.scale += -5
      this.$refs.pdf.$el.style.width = parseInt(this.scale) + '%'
    },
    pageLoaded(e) {
      this.curPageNum = e
    },
    getObjectURL(file) {
      let url = null
      if (window.createObjectURL != undefined) {
        // basic
        url = window.createObjectURL(file)
      } else if (window.webkitURL != undefined) {
        // webkit or chrome
        try {
          url = window.webkitURL.createObjectURL(file)
        } catch (error) {
          console.log(error)
        }
      } else if (window.URL != undefined) {
        // mozilla(firefox)
        try {
          url = window.URL.createObjectURL(file)
        } catch (error) {
          console.log(error)
        }
      }
      url = pdf.createLoadingTask({
        url: url,
        cMapUrl: 'https://cdn.jsdelivr.net/npm/pdfjs-dist@2.5.207/cmaps/', //加载字体包
        cMapPacked: true
      })
      return url
    }
  }
}
</script>
<style lang="scss" scoped>
.page_ {
  position: relative;
}
.btn_a {
  position: fixed;
  bottom: 10px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  padding-right: 14px;
  align-items: center;
  padding-top: 5px;
  font-size: 14px;
  .btn-def {
    background-color: #eee;
    border-radius: 4px;
    padding: 5px 10px;
    font-size: 14px;
    color: #333;
    border: none;
    margin-right: 10px;
  }
  > div {
    background-color: transparent;
  }
}
</style>
